import "./FAQ.module.css";
import Navigation from "@/reusable_sections/Header";
import FaqHero from "./sections/FaqHero";
import Inquiries from "./sections/Inquiries";
import Questions from "./sections/Questions";
import LatestTips from "./sections/LatestTips";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Navigation />
      <FaqHero />
      <Inquiries />
      <Questions />
      <LatestTips />
      <Footer />
    </div>;
}